export default "__VITE_ASSET__BSZRQoUJ__"